export default Object.freeze({
  SELECT_TEMPLATE: '톔플릿을 선택해 주세요.',
  TITLE: 'SMS 템플릿 선택',
  SMALL_TITLE: 'SMS 템플릿 유형',
  FORM_ONE: '폴더명',
  FORM_TWO: '템플릿명',
  FORM_THREE: '제목',
  FORM_FOUR: '내용',
  FORM_FIVE: '발송유형',
  GROUP_EMPTY: 'SMS템플릿 설정 탭에서 폴더/템플릿을 설정하세요.',
  TEMPLATE_EMPTY: '템플릿을 선택해 주세요.',
  SUMIT_BTN: '템플릿 선택',
  CANCEL_BTN: '닫기',
});
